var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[(_vm.is_hidden)?_c('div',{staticClass:"footer-card"},[_c('div',{staticClass:"items-footer"},[_c('div',{staticClass:"coupons-social"},[_c('Share',{attrs:{"label":"シェア","facebook":false,"twitter":false,"favorite":false,"url":_vm.urlPath,"size":"large"}})],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }